<template>
  <div
    data-qa="lpu_loyalty_program_plate"
    class="d-flex align-center gc-2 py-1 px-2 rounded special--text bg-special cursor-pointer"
    @click="emit('click')"
  >
    <span
      class="ui-icon-dzen ui-icon-fz-medium special--text flex-shrink-0"
    />
    <span class="text-body-2">{{ t('Программа лояльности', options) }}</span>
  </div>
</template>

<script lang="ts" setup>
import i18next from 'i18next'

const { t, language } = i18next
const options = { ns: language }

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()
</script>
